<template>
     <div class="home_page">
        <div class="home_carousel">
          <el-carousel :interval="5000" arrow="always">
            <el-carousel-item>
              <span class="wheatCarouselItem"></span>
            </el-carousel-item>
          </el-carousel>
        </div>
       <div class="wheat_content">
<!--         <img src="../assets/images/wheatSchool/group_two.png" alt="">-->
<!--          <img src="../assets/images/wheatSchool/group_three.png" alt="">-->
<!--          <img src="../assets/images/wheatSchool/group_four.png" alt="">-->
<!--          <img src="../assets/images/wheatSchool/group_five.png" alt="">-->
<!--          <img src="../assets/images/wheatSchool/group_six.png" alt="">-->
       </div>
     </div>
</template>

<script>
    export default {
        name: "wheatSchool"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/wheatSchool.vue